import NextLink from 'next/link';
import PropTypes from 'prop-types';

import Button from 'shopper/components/Button';
import Text from 'shopper/components/Text';

import Image from 'components/Image';

import { useUser } from 'providers/UserProvider';

const InteractionsEmptyList = ({
  userId,
  tab: {
    name,
    emptyState: {
      callToAction: { text, href },
      description,
      image,
    },
  },
}) => {
  const { LoggedInUser } = useUser();

  return (
    <div className="flex flex-col items-center justify-center py-[120px]">
      <Image alt={name} height={104} src={image} width={106} />
      <Text className="mt-10">{description}</Text>
      {text && LoggedInUser?.userId === userId && (
        <NextLink href={href} prefetch={false} passHref>
          <Button className="mt-4">{text}</Button>
        </NextLink>
      )}
    </div>
  );
};

InteractionsEmptyList.propTypes = {
  userId: PropTypes.number.isRequired,
  tab: PropTypes.shape({
    name: PropTypes.string.isRequired,
    emptyState: PropTypes.shape({
      description: PropTypes.string.isRequired,
      image: PropTypes.string.isRequired,
      callToAction: PropTypes.shape({
        text: PropTypes.string,
        href: PropTypes.string,
      }),
    }),
  }),
};

export default InteractionsEmptyList;
